export default __webpack_public_path__ + "static/media/14 1.b7d11a30.svg";